module.exports = "/_next/static/images/photoJasonMcCoy-c289201f5d05a9838cf03b884a8b87f4.webp";